export const getDeviceType = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.toLowerCase().includes('firefox')) return 'firefox';
  if (/android/.test(userAgent)) return 'android';
  if (/iphone|ios|ipad|ipod/.test(userAgent)) return 'ios';
  return 'desktop';
};
